module.exports = __webpack_public_path__ + "static/media/close-purple.513e790c.svg";